import React, { FunctionComponent, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Alert from '@justgiving/alert';
import { State } from '../../../types/state';
import { removeGlobalAlert } from './GlobalAlert.actions';
import { useLocation } from 'react-router-dom';

const GlobalAlert: FunctionComponent = () => {
  const payload = useSelector((state: State) => state.globalAlert);
  const { pathname } = useLocation();
  const previousPathname = useRef(pathname);

  const dispatch = useDispatch();

  useEffect(() => {
    if (payload !== null) window.scrollTo(0, 0);
  }, [payload]);

  // Alerts belong to the page that raised them, so clear them on navigation
  useEffect(() => {
    if (previousPathname.current !== pathname) {
      previousPathname.current = pathname;
      dispatch(removeGlobalAlert());
    }
  }, [pathname, dispatch]);

  if (!payload) return null;

  return (
    <Alert type={payload.type} onClose={() => dispatch(removeGlobalAlert())}>
      {payload.message}
    </Alert>
  );
};

export default GlobalAlert;
